module.exports = __webpack_public_path__ + "static/media/bzx.a473c64b.svg";